module.exports = __webpack_public_path__ + "static/fonts/Helvetica-Regular.d9bc516.woff2";